module.exports = __webpack_public_path__ + "static/img/manual-29.84e1f95.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/manual-29.png
// module id = tTz/
// module chunks = 4